import { Card } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import DraggableBarChart from './charts/DraggableBarChart';
import { connect } from 'react-redux';
import { compose } from 'redux';
import BaseFeature from './BaseFeature';
import PropertyPicker from './components/PropertyPicker';
import PropertyDropdown from './components/PropertyDropdown';
import { DRIVER_GUARD } from '../../../../../../utils/constantFeatures';
import { getErrorIssues } from '../../../../../../utils/validationSummary';
import { Trans, withTranslation } from 'react-i18next';

class DriverGuard extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[DRIVER_GUARD.enable].value === "1" ? true : false,
            properties: Object.assign({}, this.props.properties)
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChartChange = this.handleChartChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        this.props.handleChange(propertyName, v);

        this.setState({ properties: this.props.properties });

        if (this.getCorrectPropertyName(propertyName) === DRIVER_GUARD.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    handleChartChange(d, i) {

        this.props.handleChange(`${DRIVER_GUARD.deratingLevel}${i + 1}`, d.y);
        this.props.handleChange(`${DRIVER_GUARD.temperature}${i + 1}`, d.x);

        this.setState({ properties: this.props.properties });
    }

    render() {
        const dgEn = this.props.properties[DRIVER_GUARD.enable];
        const dgPre = this.props.properties[DRIVER_GUARD.prestartDerating];
        const dgPd = this.props.properties[DRIVER_GUARD.powertDerating];

        const powerDeratingComponent = dgPd
            ? <Card className={super.getClassName([dgPre])}>
                <div className="card-header-feature">
                    {<Trans i18nKey="Power_Settings" />}
                </div>
                <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                    <PropertyPicker
                        style={{ marginTop: '0.5rem' }}
                        disabled={!this.state.isEnabled}
                        property={dgPd}
                        title={<Trans i18nKey="Max_Power" />}
                        // title={dgPd.info.displayName}
                        measureUnit={dgPd.info.unit}
                        min={dgPd.valueMeta.min}
                        max={dgPd.valueMeta.max}
                        step={1}
                        handleChange={this.handleChange} />
                </Card.Body>
            </Card>
            : null;

        const { t } = this.props;

        return (
            <div>
                <div className="flex-row">
                    <Card className="card-feature-component">
                        <div className="card-header-feature">
                            {<Trans i18nKey="Driver_Guard" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', minWidth: '150px' }}>
                            <PropertySwitch
                                property={dgEn}
                                title={dgEn.info.displayName}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>

                    <Card className={super.getClassName([dgPre])}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Thermal_Settings" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyDropdown
                                disabled={!this.state.isEnabled}
                                style={{ marginTop: '0.5rem' }}
                                property={dgPre}
                                properties={dgPre.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                                title={dgPre.info.displayName}
                                measureUnit={'°C'}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>

                    {powerDeratingComponent}
                </div>

                <Card className={super.getClassName(this.props.properties)}>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <DraggableBarChart
                            disabled={!this.state.isEnabled}
                            containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                            properties={this.props.properties}
                            x={{ 'title': t('Temperature')+' (°C)' }}
                            y={{ 'title': t('Output_Level')+' (%)' }}
                            tickValues={{ x: [], y: [] }}
                            xThresholds={[
                                { value: 0, color: 'rgb(0,0,0)' },
                            ]}
                            xLabels={this.getXLabels(this.props.properties)}
                            yLabels={this.getYLabels(this.props.properties)}
                            handleChange={this.handleChartChange} />
                    </Card.Body>
                </Card>
            </div>
        );
    }

    getXLabels(dataChart) {
        const { t } = this.props;
        const labels = [];
        const smallLabels = [];
        const ticks = [];

        if (dataChart[DRIVER_GUARD.prestartDerating].value !== "0") {
            ticks.push(dataChart[DRIVER_GUARD.prestartDerating].value);
            labels.push({ label: dataChart[DRIVER_GUARD.prestartDerating].value, x: dataChart[DRIVER_GUARD.prestartDerating].value });
        }

        ticks.push(0);
        labels.push({ label: t('Tdriver_max'), x: 0 });

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getYLabels(dataChart) {
        const labels = {};

        //insert max label if max value is not present
        const max = 100;
        if (!labels[max]) {
            labels[max] = { label: max, y: max };
        }

        //insert min label if min value is not present
        const min = 55;
        if (!labels[min]) {
            labels[min] = { label: dataChart[DRIVER_GUARD.deratingLevel].value, y: dataChart[DRIVER_GUARD.deratingLevel].value };
        }

        return Object.keys(labels).map((key) => { return labels[key]; });
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(DriverGuard);
